<section id="app-cmp-caller">

	<form [formGroup]="CallerDataForm" class="Caller-Section" *ngIf="CallerInfo" >

	
		<div class="row p-0 pl-1 mr-2">

			<div #PhoneIcon class="col-2 p-0 pl-1 Phone-Icon-Section PhoneIconAnimation" (click)="OnCallerClick()">
				<span *ngIf="CallerInfo.CallStatus === 'Ringing' " class="p-0 pr-1 text-info "><i class="fa-solid fa-phone-volume"></i></span> 
				<span *ngIf="CallerInfo.CallStatus === 'Answered' " class="p-0 pr-1 text-success"><i class="fa-solid fa-phone-volume"></i></span> 
				<span *ngIf="CallerInfo.CallStatus === 'UnDefined' " class="p-0 pr-1"><i class="fa-solid fa-phone-volume"></i></span> 
				<span *ngIf="CallerInfo.CallStatus === 'Missed' " class="p-0 pr-1 text-danger"><i class="fa-solid fa-phone-volume"></i></span> 			
			</div>

				<!-- 1 Address found Design -->
			<div *ngIf="CallerDataForm.get('AddressForm')?.get('AddressID')?.value" class="col-9 p-0 pt-1 pl-1" (click)="OnCallerClick()">

		<div class="row p-0">

			<div class="col-3 p-0 Phone-Section">
				<span class="p-0 pr-2">{{ CallerDataForm.get('Phone')?.value }}</span>	
			</div>

			<div class="col-9 p-0 Address-Section">

				<div class="row p-0">
					<div class="col-12 p-0">
						<!-- <span class="p-0 pr-2">{{ CallerDataForm.get('Phone')?.value }}</span> -->
						<span class="p-0 pr-2">{{ CallerDataForm.get('Name')?.value }} </span>
						<span class="p-0 pr-3 float-right">{{ CallerDataForm.get('Surname')?.value }}</span>
					</div>

				</div>

				<div class="row p-0">
					<div class="col-12 p-0">
						<span class="p-0 pr-1">{{ CallerDataForm.get('AddressForm').get('Number')?.value }}</span>
						<span class="p-0 pr-1">{{ CallerDataForm.get('AddressForm').get('Street')?.value }}</span>
						<span class="p-0 pl-2 pr-1">{{ CallerDataForm.get('AddressForm').get('PostCode')?.value }} {{ CallerDataForm.get('AddressForm').get('Town')?.value }} {{ CallerDataForm.get('AddressForm').get('District')?.value }}</span>
					</div>

				</div>
			
			</div>

		</div>




			</div>

				<!-- 0 or Many Addresses Found Design -->
			<div *ngIf="!CallerDataForm.get('AddressForm')?.get('AddressID')?.value" class="col-9 p-0 CallerPhoneOnly" (click)="OnCallerClick()">

				<div class="row p-0">
					<div class="col-12 p-0">
						<span class="p-0 pr-2">{{ CallerDataForm.get('Phone')?.value }}</span>
					</div>

				</div>
			</div>

			<div class="col-1 p-0 pl-2 Close-Caller-Section" (click)="CloseCallerInfo()">
				<span class="p-0 pr-1"><i class="fa-solid fa-circle-xmark"></i></span> 
			</div>

		</div>

	
	</form>


</section>